import styled from '@emotion/styled';
import { Label } from '@fluentui/react-components';
import { IconButton, TextInput, grey, tokens } from '@galaxy-react/core';

export const TextInputStyled = styled(TextInput)({
  width: '100%',
});

export const IconButtonStyled = styled(IconButton)({
  '&.fui-Button:hover': {
    background: 'transparent',
  },
  '&.fui-Button': {
    padding: tokens.spacingHorizontalNone,
    width: '16px',
    height: '16px',
    marginLeft: tokens.spacingVerticalL,
  },
});

export const LabelStyled = styled(Label)({
  color: grey[600],
  fontSize: '12px',
});

export const TransitionInputStyled = styled(TextInput)({
  '&.fui-Input': {
    transition: 'all .5s',
    width: '500px',
    '&:focus-within': {
      width: '900px',
    },
  },
});
